export const billRatesKey = ['billRates']
export const billRatesKeyWithParams = (params: (string | number)[]) => [
  ...billRatesKey,
  ...params,
]

type BillRateShiftsKeyArgs = {
  billRateId?: number
  pageSize?: number
}

export const billRatesKeys = {
  all: billRatesKey,
  shifts: ({ billRateId, pageSize }: BillRateShiftsKeyArgs = {}) =>
    [...billRatesKey, 'shifts', billRateId, pageSize] as const,
}
